export const listMutations = <const>{
	VSTUP_PRAC_SELECT_MAPPER: 'VSTUP_PRAC_SELECT_MAPPER',
	SKLAD_MISTO_PREDMETU_SELECT_MAPPER: 'SKLAD_MISTO_PREDMETU_SELECT_MAPPER',
};

export const editMutations = <const>{
	SKLAD_MISTO_PREDMETU_SELECT_MAPPER: 'SKLAD_MISTO_PREDMETU_SELECT_MAPPER',
	NAKLAD_STREDISKO_SELECT_MAPPER: 'NAKLAD_STREDISKO_SELECT_MAPPER',
};
